/**
 * Lightweight masking helpers for PII display in operator-facing tables.
 * The PIIField component uses these to hide sensitive values until a user
 * explicitly reveals them (which writes an audit log entry).
 */

export function maskEmail(email: string | null | undefined): string {
  if (!email) return '—';
  const [local, domain] = email.split('@');
  if (!domain) return email;
  if (local.length <= 1) return `•@${domain}`;
  return `${local[0]}${'•'.repeat(Math.min(local.length - 1, 5))}@${domain}`;
}

export function maskPhone(phone: string | null | undefined): string {
  if (!phone) return '—';
  // Preserve country code prefix (e.g. "+91 ") and last 2-3 digits.
  const trimmed = phone.trim();
  const m = trimmed.match(/^(\+\d{1,3})?\s?(.+)$/);
  const prefix = m?.[1] ? `${m[1]} ` : '';
  const rest = m?.[2] ?? trimmed;
  const digits = rest.replace(/\D/g, '');
  if (digits.length <= 3) return phone;
  const tail = digits.slice(-3);
  return `${prefix}••••• ${tail}`;
}

export function maskName(name: string | null | undefined): string {
  if (!name) return '—';
  const parts = name.trim().split(/\s+/);
  if (parts.length === 1) return `${parts[0][0]}${'•'.repeat(Math.max(parts[0].length - 1, 1))}`;
  const first = parts[0][0];
  const last = parts[parts.length - 1];
  return `${first}. ${last[0]}${'•'.repeat(Math.max(last.length - 1, 1))}`;
}

export function maskAddressLine(line: string | null | undefined): string {
  if (!line) return '—';
  if (line.length <= 6) return '••••••';
  return `${line.slice(0, 4)}${'•'.repeat(Math.min(line.length - 4, 12))}`;
}
